import groq from 'groq';

import { CLOUDINARY_VIDEO, RICH_TEXT, STUDY_MODAL } from '../common';

export const MITOCHONDRIAL_DECLINE = groq`
  _type,
  title,
  description[] {
    ${RICH_TEXT}
  },
  modal-> { ${STUDY_MODAL} },
  bulletPoints,
  video { ${CLOUDINARY_VIDEO} },
`;

export const MITOCHONDRIAL_DECLINE_BLOCK = groq`
  _type == 'mitochondrialDecline' => @-> {
    ${MITOCHONDRIAL_DECLINE}
  }
`;
